// Backend uses uppercase enum values: ADULT, CHILD
export type Audience = "ADULT" | "CHILD";

export const AUDIENCE_LABEL: Record<Audience, string> = {
  ADULT: "adult",
  CHILD: "child",
};

export type AudienceAgeRange = "under-18" | "18+";

export const audienceFromAgeRange = (
  ageRange: AudienceAgeRange
): Audience => {
  return ageRange === "under-18" ? "CHILD" : "ADULT";
};
